// Track phone call conversions with Google Ads
export const trackPhoneCallConversion = () => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      'send_to': 'AW-16986363672/fJRpCPScxcMbEJiu3aM_'
    });
  }
};

// Extend Window interface for TypeScript
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}
